/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//h.cdn.pengpengla.com/squid-h5/website-fanle-en/1.0.1/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);

__webpack_require__(3);

var _about = __webpack_require__(4);

var _about2 = _interopRequireDefault(_about);

var _about3 = __webpack_require__(5);

var _about4 = _interopRequireDefault(_about3);

var _about5 = __webpack_require__(6);

var _about6 = _interopRequireDefault(_about5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var temp = '\n<header>\n    <p><span>Beijing Fanle Technology</span></p>\n    <h1>Committed to bringing high-quality Internet innovative products and services to global users</h1>\n</header>\n<div class="content">\n    <div class="about">\n        <h2>Company Introduction</h2>\n        <p>The company currently has 30 employees and a professional team composed of industry elites. The core team brings together outstanding talents from many first-class social companies at home and abroad. They have rich experience, superb technology and keen market insight, and continue to promote the development and progress of the company, and continue to provide high-quality experience for users in China and around the world.</p>\n    </div>\n    <div class="about-item">\n        <div class="about-item-img">\n            <img src="' + _about2.default + '" alt="">\n        </div>\n        <div class="about-item-text">\n            <h2>High-quality products and services</h2>\n            <p>In terms of accuracy, we will repeatedly verify all kinds of information and cooperate with third-party information security service platforms such as Shumei. We continue to optimize the content review process and introduce advanced technical means to assist the review work. Through the intelligent algorithm, the content is preliminarily screened, which improves the efficiency of the review and further reduces the error rate. The pursuit of professionalism also runs through the review. From the in-depth analysis of technical documents to the unique insights of market analysis, we examine every expression with a professional eye, from the standardization of language expression to the accuracy of industry terms, from the rationality of typesetting layout to the coordination of pictures and texts, we will strictly control. Legality review cannot be sloppy. Strictly abide by national laws and regulations and Internet specifications, and strictly screen all content. Any content that may involve violations of laws and regulations will be resolutely intercepted to create a safe and secure browsing environment for users.</p>\n        </div>\n    </div>\n    <div class="about-item">\n        <div class="about-item-text">\n            <h2>Perfect network information security technology</h2>\n            <p>We adopt a multi-layer security strategy, from firewalls to intrusion detection systems, to provide all-round protection. We are equipped with professional maintenance personnel to monitor the system that provides services to users around the clock, and monitor and predict potential security threats in real time. We correctly handle user request services within the required time and reply to the user\'s request content to ensure that the content is accurate.</p>\n            <p>We deploy advanced security solutions, such as data encryption storage, network access control, and security auditing, to effectively prevent various network threats and ensure the continuous and stable operation of the business.\n            Use backup technology to improve the integrity of data recovery. The backup work can be done manually or automatically. Since the backup itself contains confidential information, the backup medium is also the target of thieves. Therefore, the computer system allows some special files of users to be backed up by confidential media instead of system backup.\n            Use anti-virus, security patch programs, physical environment security, LAN firewall system, network security audit system, log analysis, encryption, information filtering and other means to ensure the security and stability of the network.</p>\n        </div>\n        <div class="about-item-img">\n            <img src="' + _about4.default + '" alt="">\n        </div>\n    </div>\n    <div class="about-item">\n        <div class="about-item-img">\n            <img src="' + _about6.default + '" alt="">\n        </div>\n        <div class="about-item-text">\n            <h2>Reliable emergency response plan</h2>\n            <p>We monitor users from a technical perspective through advanced monitoring tools. Once a problem is discovered, we can quickly identify security incidents and assess their severity and scope of impact. We maintain a legal and compliant environment and provide users with a healthy and orderly platform.</p>\n        </div>\n    </div>\n</div>\n<footer>\n    <p>Beijing Fanle Technology Co.,Ltd.</p>\n</footer>\n'; // import '../util/m-base'

document.querySelector('#wrap').innerHTML = temp;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "547ac200a1819e7c8d8e4902d1abf229.png";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0bb4b0bb0fede094f6862a347f7e681.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4f31f70d4d199e0777e342763346155.png";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js